import React from 'react';
import Top from './Top';
import About from './About';
import Drink from './Drink';
import Footer from './Footer';
import Detail from './Detail';
import { Route, Switch } from 'react-router-dom';

export default class index extends React.Component {
    render() {
        return (
            <div>
                <Top />
                <Switch>
                    <Route path="/detail/:drinkname" component={Detail} />
                    <Route path="/">
                        <About />
                        <Drink />
                    </Route>
                </Switch>
                <Footer />
                <div class="fixed bottom-0 right-0 h-auto p-2 xl:pr-24">
                    <a href="https://line.me/R/ti/p/Ndtea3GYpS">
                        <div class="adv w-24 h-24 sm:w-20 sm:h-20"></div>
                    </a>
                </div>
            </div>
        )
    }
}